export async function fetchDeployedVersion() {
  const base = process.env.PUBLIC_URL || '';
  const url = `${base}/version.json?t=${Date.now()}`;

  const response = await fetch(url, { cache: 'no-store' });
  if (!response.ok) {
    throw new Error('version.json not available');
  }

  return response.json();
}

export async function fetchDeployedReleases() {
  const base = process.env.PUBLIC_URL || '';
  const url = `${base}/releases.json?t=${Date.now()}`;

  const response = await fetch(url, { cache: 'no-store' });
  if (!response.ok) {
    throw new Error('releases.json not available');
  }

  const data = await response.json();
  return Array.isArray(data) ? data : [];
}
